import { Modal } from 'antd'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import { SignerApi } from '../../api/SignerApi'
import { GlobalHandler } from '../../utils/ReduxUtils'
import {
  certificateLisFullfilled,
  certificateLisRejected,
  certificateListRequest,
  terminalisFullfilled,
  terminalListRequest,
} from './actions'
import { ActionTypes } from './types'

function* handleCertificateListRequest(action: ReturnType<typeof certificateListRequest>) {
  const { response, error } = yield GlobalHandler(
    call(SignerApi.getCertificateList, action.payload),
  )

  if (response) return yield put(certificateLisFullfilled(response))
  if (error) {
    const message = (error.response.data != undefined
      ? error.response.data.message
      : error.response.message) as string

    if (message.indexOf('wrapper') >= 0) {
      yield put(certificateLisRejected(error))
    } else {
      Modal.error({
        title: 'Bir hata oluştu',
        content: message,
      })
    }
  }
}

function* handleTerminalListRequest(action: ReturnType<typeof terminalListRequest>) {
  const { response, error } = yield GlobalHandler(call(SignerApi.getSmartCardList))
  if (response) yield put(terminalisFullfilled(response))

  if (error) {
    Modal.error({
      title: 'Akıllı kart listesi alınamadı',
      content: error.response != undefined ? error.response.data.message : error.toString(),
    })
  }
}

function* SmartCardSaga() {
  yield all([
    takeLatest(ActionTypes.CERTIFICATE_LIST_REQUEST, (action: any) =>
      handleCertificateListRequest(action),
    ),
    takeLatest(ActionTypes.TERMINAL_LIST_REQUEST, action => handleTerminalListRequest(action)),
  ])
}

export default SmartCardSaga
